
import axios from 'axios'
import { url } from './url'
import queryStringUtil from "query-string";

function getStocks(query) {
    var urlString = `${url}/stock?${queryString(query)}`;
    return axios
        .get(urlString)
        .then(res => res.data);
}
function getStockDevices() {
    var urlString = `${url}/stock-devices`;
    return axios
        .get(urlString)
        .then(res => res.data);
}

function queryString(query) {
    var queryParams = {
        ...query
    };
    return queryStringUtil.stringify(queryParams, {
        arrayFormat: "bracket"
    });
}
function updateStock({_id,amount}) {
    return axios.post(`${url}/stock/${_id}`, {amount:amount})
        .then(resp => {
            return resp.data
        })
}

function saveMinQuantity({id,value}){
    return axios.post(`${url}/stock/${id}/min-quantity`, {value})
        .then(resp => {
            return resp.data
        })
    
}

function createStock(stock) {
    return axios.post(`${url}/stock`, stock)
        .then(resp => {
            return resp.data
        })
}
function deleteStock(id) {
    return axios.delete(`${url}/stock/${id}`)
        .then(resp => {
            return resp.data
        })
}
export default {
    getStocks,
    getStockDevices,
    createStock,
    updateStock,
    saveMinQuantity,
    deleteStock
};